import { render, staticRenderFns } from "./news-list-comp.vue?vue&type=template&id=02e861b6&scoped=true&"
import script from "./news-list-comp.vue?vue&type=script&lang=js&"
export * from "./news-list-comp.vue?vue&type=script&lang=js&"
import style0 from "./news-list-comp.vue?vue&type=style&index=0&id=02e861b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e861b6",
  null
  
)

export default component.exports